// @ts-nocheck
/* eslint-disable */
import Content from './content';

export default class KeyValue extends Content {
	_build() {
		this._dom.container.classList.add("content-keyvalue");
		var d = this._data.value;

		var nodes = [];
		for (var i = 0; i < (d || []).length; i++) {
			var item = d[i];

			if (item.key && !item.value) {
				nodes.push('<tr><td colspan="2" class="only-key">' + item.key + "</td></tr>");
			}
			else if(item.key) {
				nodes.push('<tr><td class="text">' + item.key +":</td><td>" + item.value + "</td></tr>");
			} else {
				nodes.push('<tr><td colspan="2">' + item.value + "</td></tr>");
			}
		}

		if (nodes.length) {
			this._dom.container.innerHTML = "<table><tbody>" + nodes.join("") + "</tbody></table>";
		}
	}
}
